module.exports = __webpack_public_path__ + "img/appstore.5e70e834.svg";